import React from 'react';
import { renderStepArguments } from '../..';
import StepContainer from '../StepContainer';
import PIEText from '@src/shared/components/PIEText';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import { useTranslation } from 'react-i18next';

interface componentProps {
  onStepClose: () => void;
}
export const DashboardOnboardingContentStep2 = ({
  closeTutorial,
  nextStep,
  previousStep,
  onStepClose,
}: renderStepArguments & componentProps) => {
  const { isResolutionMobile, isTablet } = useDeviceDetect();
  const { t } = useTranslation();

  return (
    <StepContainer
      title={
        <PIEText
          text={t('onboarding_dashboard.STEP_2_TITLE')}
          size="var(--xds-font-size-20)"
          align="left"
          color="var(--xds-color-content-light)"
          fontWeight="var(--xds-font-weight-bold)"
        />
      }
      totalSteps={6}
      currentStep={2}
      onClose={() => {
        closeTutorial();
        onStepClose();
      }}
      onNext={() => nextStep()}
      onPrevious={() => previousStep()}
      width={isResolutionMobile && !isTablet ? '95vw' : '450px'}
    >
      <PIEText
        text={t('onboarding_dashboard.STEP_2_CONTENT')}
        size="var(--xds-font-size-16)"
        align="left"
        color="var(--xds-color-content-light)"
        fontWeight="var(--xds-font-weight-regular)"
      />
    </StepContainer>
  );
};
